<template>

<div style="max-width: 1280px;">

    <v-row>

        <v-col cols="12" lg="12" md="12" class="d-flex flex-column">

            <v-card outlined class="mb-4" >

                <v-card-text>
                    <div v-if="isLoading" class="text-center ma-12">
                        <v-progress-circular size="48" width="4" indeterminate color="grey lighten-2"></v-progress-circular>
                    </div>
                    <div v-else style="white-space: pre-line;">
                        {{ releaseNotes }}
                    </div>
                </v-card-text>

            </v-card>

        </v-col>


    </v-row>

</div>


</template>

<script>
import Vue from 'vue';

export default {

    components: {

    },

    data: function() {

        return {
            isLoading: true,
            releaseNotes: null,

        }
    },

    created() {

        this.initialize();


    },


    mounted() {

    },

    methods: {


        initialize() {

            this.isLoading = true;

            this.axios.get('teachin/releaseNotes')
                .then(res => {

                    this.releaseNotes = res.data;

                }).catch(error => {

                    console.error(error)

                }).finally(() => {

                    setTimeout(() => {
                        this.isLoading = false;
                    }, 500);

                });


        }


    }


}

</script>

<style lang="scss">



</style>
